import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss']
})
export class DiscountsComponent implements OnInit {

  closeResult = '';
  bearer;

  store_id;
  discounts = [] ;
  discount_id =[];
  voucherList = [];
  promotionList = [];
  actionProductList = '';
  actionProduct = [];
  promotion = [];
  promotion_id = [];
  p_id : any;
  qtyClick:number = 0;
  configP_id ='';
  qtyselect = [];
  deleteid:any;

  success;

  
  productNameFilter;
  countryFilters = [];
  statusFilters = []
  selectedStatus;

  clickEventsubscription: Subscription;
  loading = true;

  selectedVoucer = '';
  selectedVoucerId;
  promoActionId:number;
  promoActionQty;
  promoActionFixQty: boolean ;
  promotion_config = [];
  promotionForm!: FormGroup;
  // promotion: any;
  formError = false;
	itemValidation: any = [false,false];
  updateSuccess = false;
  country_code: any;
  selectVoucherShow: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private modalService: NgbModal,
    private router: Router,
    public utils: UtilitiesService,
  ) {
    // Change store_id accordingly
    this.clickEventsubscription = storeService.getClickEvent().subscribe(()=>{
      const store_id = localStorage.getItem('store_id');
      if(store_id) {
        this.store_id = parseInt(store_id);
      }
      // this.getStoreDiscount();
      this.getStorePromotion();
    })
  }

  ngOnInit(): void {
    // Change template based on store_id
    const store_id = localStorage.getItem('store_id');
    this.bearer = localStorage.getItem('bearer');

    if(store_id) {
      this.store_id = parseInt(store_id);
    }
    
    // this.getStoreDiscount();
    // this.getDiscountList();
    this.getPromotionList();
    this.getStorePromotion();
  }

  // getStoreDiscount() {

  //   this.storeService.getStoreDiscount(this.store_id,this.bearer).subscribe(res=>{
  //     this.discount_id = [];
  //     this.discounts = Object.keys(res['data']).map(index => {
  //       let disc = res['data'][index];
  //       this.discount_id.push(disc['p_id']);        
  //       return disc;
  //     });

  //     console.log("discounts ==",this.discounts);

  //     const filters = ['ALL', ...[...new Set( this.discounts.map(item => item.country_code))].sort()];
  //     this.statusFilters = filters.map(item => ({ display: item, value: item }));
    
  //     const statVal = this.selectedStatus;

  //     if (this.selectedStatus && statVal != 'ALL') {
  //       this.discounts =  this.discounts.filter(item => item.country_code == statVal);
  //     }
      
  //     this.loading = false;
  //   },(err)=>{
  //     this.discounts = [];
  //     this.loading = false;
  //   })
  // }

  // getDiscountList(){
  //   this.storeService.getDiscountList(this.store_id, this.bearer).subscribe(res2=>{
  //     this.voucherList = Object.keys(res2['data']).map(index2 => {
  //       let discList = res2['data'][index2];
  //       return discList;
  //    });
  //    console.log("list",this.voucherList);
  //    if (this.voucherList.length == 0) {
  //     this.selectVoucherShow = false;
  //    };
  //   }, error => {
  //       this.loading = false;
  //   })
  // }

  getStorePromotion() {

    this.storeService.getStorePromotion(this.store_id,this.bearer).subscribe(res=>{
      this.promotion_id = [];
      this.promotion = Object.keys(res['data']).map(index => {
        let disc = res['data'][index];
        this.promotion_id.push(disc['p_id']);        
        return disc;
      });

      console.log("storepromotionlist ==",this.promotion);

      const filters = ['ALL', ...[...new Set( this.promotion.map(item => item.country_code))].sort()];
      this.statusFilters = filters.map(item => ({ display: item, value: item }));
    
      const statVal = this.selectedStatus;

      if (this.selectedStatus && statVal != 'ALL') {
        this.promotion =  this.promotion.filter(item => item.country_code == statVal);
      }
      
      this.loading = false;
    },(err)=>{
      this.promotion = [];
      this.loading = false;
    })
  }

  getPromotionList(){
    this.storeService.getPromotionList(this.store_id, this.bearer).subscribe(res2=>{
      this.promotionList = Object.keys(res2['data']).map(index2 => {
        let discList = res2['data'][index2];
        let requirement = JSON.parse(discList['requirement']);
     
        return discList;
     });
     console.log("promotionlist",this.promotionList);
     if (this.promotionList.length == 0) {
      this.selectVoucherShow = false;
     };
    }, error => {
        this.loading = false;
    })
  }

  filterCountry(filter){
    this.selectedStatus = filter.value;
    this.discounts = []
    this.loading = true;
    // this.getStoreDiscount();
    this.getStorePromotion();
  }

  open(content, id) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      console.log(result);
      console.log(id);
      if(result == 'delete') {
        this.deletePromotion(id);
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  successModal(success) {
      if (!this.updateSuccess) {
        return;
      }
      this.updateSuccess = false;
      this.modalService.open(
          success, {
              ariaLabelledBy: 'modal-basic-title',
              size: 'sm',
              windowClass: 'modal-success',
              centered: true,
              backdrop: 'static'
          }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          // location.reload();
          this.modalService.dismissAll();

      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          //location.reload();
          this.modalService.dismissAll();
      });
      //location.reload();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  deletePromotion(id: number) {
    // remove discount id in array
    if (this.promotion_id.includes(id)) {
      this.promotion_id.splice(this.promotion_id.indexOf(id), 1); 
    }

    // const curr_ids = this.discount_id.join(","); 

    // const params = {
    //   store_id:this.store_id.toString(),
    //   discount_id: curr_ids.length != 0 ? curr_ids : [0]
    // };
    // console.log(params);
    this.deleteid = id;
    this.storeService.deleteStorePromotion(this.store_id,this.deleteid,this.bearer).subscribe(res=>{
      console.log(res['status']);

      if(res['status'] == 'success') {
        // this.getStoreDiscount();
        // this.getDiscountList();
        this.getStorePromotion();
        this.getPromotionList();
        this.discount_id =[];
        this.toast('Promotion deleted successfully!',3000);
      }
      else {
        this.toast('Promotion delete failed!',3000);
      }
    },(err)=>{
      this.toast('Promotion delete failed!',3000);
      this.discount_id = [];
    })
  }

  toast(msg:string, timeout:number){
    if(msg == 'Discount delete failed!'){
      this.utils.notify.showError(msg);
    }else{
      this.utils.notify.showSuccess(msg);
    }
  }

  getFlagByCountryCode (country_code:string){
    country_code = (country_code || '').toLowerCase().substr(-2,2);
    country_code = (country_code === "cm")?"kh":country_code;
    return country_code;
  }

  getValue (num){
    return Math.abs(num)
  }

  /*-------      add discount code        -----------*/
  selectVoucher(voucher: string, p_id: number, action_product: string) {
    this.selectedVoucer = voucher;
    this.actionProductList = action_product;
    this.promotion_config = [];
    this.p_id = p_id;
    console.log('promoid',this.p_id);
    for(var item of this.actionProductList){

    this.promoActionId = item['p_id'];
    this.promoActionQty = item['qty'];
    this.promoActionFixQty = item['fixed_qty'];

    
    if (this.promoActionFixQty ===true){
      this.promotion_config.push({p_id:this.promoActionId,qty:this.promoActionQty});
    }
    if(this.promoActionFixQty ===false){
      // console.log('here inside')
      this.promotion_config.push({p_id:this.promoActionId,qty:this.qtyClick});
    }
    
    this.configP_id = JSON.stringify(this.promotion_config);
    // console.log('action fixqty',this.promoActionFixQty);
    // console.log('action config',this.configP_id);
    }
    // console.log('selected vouchername ',this.actionProductList.indexOf['p_id']);
    this.selectedVoucerId = p_id;

  }

  selectActionQty(qty:number,pid:number){
    let t = qty;
    this.qtyClick = t;
    this.qtyselect = [];
    this.qtyselect.push({p_id:pid,qty:this.qtyClick});

    this.promotion_config.forEach(e1 => {
      var e2 = this.qtyselect.find( e => e.p_id === e1.p_id );
        if (e2) { 
          e1.qty = e2.qty; 
          e1.qty =parseInt(e1.qty);
        }
    });

    this.configP_id = JSON.stringify(this.promotion_config);

    console.log('action config update',this.configP_id);
  }

  addDiscount(id: number, promotion_config: string) {

    if (!id)
        return;

    this.updateSuccess = true;
    // this.promotion_id.push(id,promotionConfig);
    // console.log('promoidAdd',this.promotion_id);
    // const params = {
    //   store_id:this.store_id.toString(),
    //   promotion_id:this.promotion_id

    // };

    this.storeService.addStorePromotion(this.store_id,this.p_id,this.configP_id, this.bearer).subscribe(res=>{
      console.log(res);
      console.log("storeservice",this.storeService.getStorePromotion);
      // this.getStoreDiscount();
      this.getStorePromotion();
      this.getPromotionList();
      this.promotion_id =[];
      this.selectedVoucer = '';
      this.selectedVoucerId = '';
      
      this.toast('Discount added successfully!',3000);
    },(err)=>{
      this.utils.notify.showError(this.utils.translate("Add Discount failed!"));

        this.selectedVoucer = '';
        this.selectedVoucerId = '';
    })
    // this.storeService.updateStoreDiscount(params, this.bearer).subscribe(res=>{
    //   console.log(res);
    //   console.log("storeservice",this.storeService.updateStoreDiscount);
    //   this.getDiscountList();
    //   this.getStoreDiscount();
    //   this.discount_id =[];
    //   this.selectedVoucer = '';
    //   this.selectedVoucerId = '';
      
    //   this.toast('Discount added successfully!',3000);
    // },(err)=>{
      
    //   this.toastErrorMsg = 'Add Discount failed!';
    //     this.toastError = true;
    //     setTimeout(()=>{
    //       if(this.toastError) this.toastError = false;
    //     },3000)
        

    //     this.getDiscountList();
    //     this.selectedVoucer = '';
    //     this.selectedVoucerId = '';
    // })
  }

togglehidden(){
  if(this.selectVoucherShow == false){
    this.selectVoucherShow = true;
  }else{
    this.selectVoucherShow = false;
  }
}

}
